import { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
};

/**
 * Password input with an eye toggle. Forward-refs so it composes with
 * react-hook-form's `register()`.
 */
export const PasswordField = forwardRef<HTMLInputElement, Props>(
  function PasswordField({ invalid, className = "", ...rest }, ref) {
    const [show, setShow] = useState(false);
    const base =
      "w-full rounded-md border px-3 py-2 text-sm pr-10 focus:outline-none focus:ring-1";
    const border = invalid
      ? "border-red-400 focus:border-red-500 focus:ring-red-500"
      : "border-slate-300 focus:border-brand-500 focus:ring-brand-500";
    return (
      <div className="relative">
        <input
          ref={ref}
          type={show ? "text" : "password"}
          className={`${base} ${border} ${className}`}
          autoComplete="current-password"
          {...rest}
        />
        <button
          type="button"
          aria-label={show ? "Hide password" : "Show password"}
          onClick={() => setShow((s) => !s)}
          className="absolute inset-y-0 right-0 grid place-items-center px-3 text-slate-400 hover:text-slate-700"
          tabIndex={-1}
        >
          {show ? (
            <EyeOff className="h-4 w-4" />
          ) : (
            <Eye className="h-4 w-4" />
          )}
        </button>
      </div>
    );
  },
);
